import React from 'react'
import { tableData } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals"
import { formatDate } from "@ui-seeker/utils"
import { alpha, Box, Grid, Typography } from "@mui/material"
import { COMPARISON_TYPE } from "Pages/BusinessLogistics/LeadingAnalyzer/Page/@constants"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import { rentacarPalette as palette } from "Theme/palette"

const mapColors = {
	[COMPARISON_TYPE.LESS]: palette.error.light,
	[COMPARISON_TYPE.MORE]: palette.info.main
}

const evolutionIcons = {
	[COMPARISON_TYPE.LESS]: { color: "error.main", icon: "arrow-down" },
	[COMPARISON_TYPE.MORE]: { color: "success.dark", icon: "arrow-up" },
	[COMPARISON_TYPE.EQUAL]: { icon: "equals" },
}

export default function priceColumn(value) {

	return {
		name: value,
		headerAlign: "center",
		options: {
			filter: false,
			sort: false,
			customHeadLabelRender: () => <Box
				sx={{
					fontWeight: 600,
					display: 'block',
					textAlign: 'center'
				}}>
				{tableData.value.isDaily ? formatDate(value, { isString: true }) : value}
			</Box>,
			customBodyRowRenderLite: cellData => <PriceColumnCell cellData={cellData}/>,
		}
	}
}


function PriceColumnCell({ cellData }) {
	const {
		name,
		main_price,
		price,
		comparison_type,
		diff_price,
		noResult,
	} = cellData
	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "default" }}>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-around",
				flexDirection: "row",
				borderRadius: "5px",
				border: 2,
				width: 170,
				minHeight: 40,
				borderColor: (!noResult || !!main_price) ? mapColors[comparison_type] || 'secondary.light' : 'transparent',
				backgroundColor: alpha(mapColors[comparison_type] || '#fff', 0.1),
			}}
		>
			<Grid container spacing={1}>
				<Grid item xs={(!!main_price && !!diff_price) ? 7 : 12}
					  sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
					<TooltipSeeker title="Main Price">
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.2 }}>
							<Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
								{!!main_price ? main_price : 'N/A'}
							</Typography>
							{!!main_price && !!price && (
								<Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
									{price}
								</Typography>
							)}
						</Box>
					</TooltipSeeker>
				</Grid>
				{!!diff_price &&
					<Grid item xs={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", gap: .5 }}>
						<TooltipSeeker title={`Difference between main price and ${name} price`} componentsProps={{ sx: { display: "flex" } }}>
							<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", gap: .5 }}>
								<IconSeeker {...evolutionIcons[comparison_type]} sx={{ mt: .2 }}/>
								<Typography variant="body2">{diff_price}%</Typography>
							</Box>
						</TooltipSeeker>
					</Grid>}
			</Grid>
		</Box>
	</Box>

}